import { BackendMessagesEN } from './backendMessagesEN';
import buildingEN from './messages/building.json';
import dashboardCustomizeEN from './messages/dashboard/customize.json';
import dashboardCustomTabsEN from './messages/dashboard/customTabs.json';
import dashboardEN from './messages/dashboard/dashboard.json';
import dashboardWidgetLibraryEN from './messages/dashboard/widgetLibrary.json';
import dashboardWidgetsEN from './messages/dashboard/widgets.json';
import invoiceLifecycleEN from './messages/invoiceLifecycle.json';
import leaseInventoryEN from './messages/leaseInventory.json';
import propertySiteEN from './messages/propertySite.json';
import tagEN from './messages/tag.json';
import technicEN from './messages/technic.json';
import ticketsEN from './messages/tickets.json';

export const MessagesEN = {
  ...BackendMessagesEN,
  building: buildingEN,
  dashboard: {
    ...dashboardEN,
    widgets: dashboardWidgetsEN,
    widgetLibrary: dashboardWidgetLibraryEN,
    customize: dashboardCustomizeEN,
    customTabs: dashboardCustomTabsEN,
  },
  invoiceLifecycle: invoiceLifecycleEN,
  leaseInventory: leaseInventoryEN,
  propertySite: propertySiteEN,
  tag: tagEN,
  technic: technicEN,
  tickets: ticketsEN,
};
